import * as React from 'react'
import * as css from './ExpertiseList.module.css'
import HTag from 'components/common/HTag'
import { Link } from 'gatsby'
import HexPattern from 'components/common/HexPattern'
import Img from 'components/common/Img'
import resolveLink from 'utils/resolveLink'

const ExpertiseList = ({ heading, description, items }) => (
  <section className="pt-20 pb-[1px] overflow-hidden">
    <header className="relative">
      <div className="relative z-[1] max-w-screen-lg mx-auto px-8">
        <div className="md:mr-[20vw]">
          <HTag className="technical-lg mb-4 text-3xl" {...heading} />
          {!!description && (
            <p
              className={css.desc}
              dangerouslySetInnerHTML={{ __html: description.replace(/\n/, '<br/>') }}
            />
          )}
        </div>
      </div>

      <HexPattern className="right-0 top-1/2 -translate-y-1/2 -scale-x-100" />
    </header>

    <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-[1px] mt-20 md:ml-[5vw]">
      {items?.map((item, key) => (
        <ExpertiseItem {...item} key={key} />
      ))}
    </div>
  </section>
)

export default ExpertiseList

const ExpertiseItem = ({ page, title, description, image }) => (
  <Link className={css.item} to={resolveLink(page)}>
    {!!image?.image && (
      <figure className="absolute inset-0 flex-grow">
        <Img className="grayscale w-full h-full" {...image} />

        {image.caption && (
          <figcaption className="location-caption mb-0">
            <span className="action">{image.caption}</span>
          </figcaption>
        )}
      </figure>
    )}

    <div className="relative p-8 overflow-hidden md:max-w-[450px] bg-gradient-to-br from-ft-green-light/90 to-ft-green-dark/90 text-white richtext">
      <h3 className={`${css.title} h3 technical-lg`}>{title || page?.title}</h3>
      {!!description && <p className={`${css.desc} md:max-h-[7em] transition-all`}>{description}</p>}
    </div>
  </Link>
)
